interface IConfig {
  APP_NAME: string;
  API_ROOT: string;
  STATIC_ROOT?: string;
}

const config: IConfig = {
	APP_NAME: "Test App",
	API_ROOT: process.env.REACT_APP_ROOT_API || "",
	STATIC_ROOT: process.env.REACT_APP_ROOT_STATIC_FILES_DIR || "",
};
export default config;
